const NotFoundEN = {
  NotFound: {
    PAGE_NOT_FOUND: 'Page not found!',
    PAGE_NOT_FOUND_SUBTITLE: "Sorry! We couldn't find this page.",
    GO_BACK_HOME: 'Go back home',
  },
};

const NotFoundPT = {
  NotFound: {
    PAGE_NOT_FOUND: 'Página não encontrada!',
    PAGE_NOT_FOUND_SUBTITLE: 'Desculpe! Não conseguimos encontrar esta página.',
    GO_BACK_HOME: 'Voltar para página inicial',
  },
};

export { NotFoundPT, NotFoundEN };
